"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMediaQueryString = function (queryBreakPoint) {
    var _a = react_1.useState(false), matches = _a[0], setMatches = _a[1];
    react_1.useEffect(function () {
        var media = window.matchMedia(queryBreakPoint);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function () { return setMatches(media.matches); };
        window.addEventListener('resize', listener);
        return function () { return window.removeEventListener('resize', listener); };
    }, [matches, queryBreakPoint]);
    return matches;
};
exports.default = useMediaQueryString;
//# sourceMappingURL=use-media-query-string.hook.js.map